import { Injectable } from "use-vue-service";

import { LoggerService } from "./logger.service";

export enum TodoStatus {
  Active = 1,
  Completed
}

export interface Todo {
  name: string;
  status: TodoStatus;
}

@Injectable()
export class TodoService {
  public todoList = [] as Todo[];
  public viewStatus = 0;

  constructor(private logger: LoggerService) {}

  public updateViewStatus(status: number) {
    this.viewStatus = status;
    this.logger.info("updateViewStatus", status, this.todoList);
  }

  public toggleTodoStatus(todo: Todo) {
    if (todo.status === TodoStatus.Active) {
      todo.status = TodoStatus.Completed;
    } else {
      todo.status = TodoStatus.Active;
    }
    this.logger.info("toggleTodoStatus", todo, this.todoList);
  }

  public clearCompletedTodos() {
    this.todoList = this.todoList.filter(
      todo => todo.status === TodoStatus.Active
    );
    this.logger.info("clearCompletedTodos", this.todoList);
  }

  public removeTodo(todo: Todo) {
    this.todoList = this.todoList.filter(td => td !== todo);
    this.logger.info("removeTodo", todo, this.todoList);
  }

  public addTodo(name: string) {
    this.todoList = this.todoList.concat({
      name,
      status: TodoStatus.Active
    });
    this.logger.info("addTodo", name, this.todoList);
  }

  public updateTodo(todo: Todo, name: string) {
    todo.name = name;
    this.logger.info("updateTodo", name, this.todoList);
  }

  public get viewTodoList() {
    return this.todoList.filter(
      todo => this.viewStatus === 0 || todo.status === this.viewStatus
    );
  }
}
